import * as ActuatorCatalog from './documents/ActuatorCatalog';
import * as BlowerCatalog from './documents/BlowerCatalog';
import * as ChlorineSensorCatalog from './documents/ChlorineSensorCatalog';
import * as DissolvedOxygenSensorCatalog from './documents/DissolvedOxygenSensorCatalog';
import * as FlowMeterCatalog from './documents/FlowMeterCatalog';
import * as HeaterCatalog from './documents/HeaterCatalog';
import * as LightCatalog from './documents/LightCatalog';
import * as LightDriverCatalog from './documents/LightDriverCatalog';
import * as PressureSensorCatalog from './documents/PressureSensorCatalog';
import * as PumpCatalog from './documents/PumpCatalog';
import * as RemoteCatalog from './documents/RemoteCatalog';
import * as SwgCatalog from './documents/SwgCatalog';

export enum CatalogFileNames {
    ActuatorCatalog = "ActuatorCatalog.json",
    BlowerCatalog = "BlowerCatalog.json",
    ChlorineSensorCatalog = "ChlorineSensorCatalog.json",
    DissolvedOxygenSensorCatalog = "DissolvedOxygenSensorCatalog.json",
    FlowMeterCatalog = "FlowMeterCatalog.json",
    HeaterCatalog = "HeaterCatalog.json",
    LightCatalog = "LightCatalog.json",
    LightDriverCatalog = "LightDriverCatalog.json",
    PressureSensorCatalog = "PressureSensorCatalog.json",
    PumpCatalog = "PumpCatalog.json",
    RemoteCatalog = "RemoteCatalog.json",
    SwgCatalog = "SwgCatalog.json",
}

export type CatalogRealms = "prod" | "dev" | "qa";

export class AllCatalogs {
    Actuator: ActuatorCatalog.ActuatorCatalog;
    Blower: BlowerCatalog.BlowerCatalog;
    ChlorineSensor: ChlorineSensorCatalog.ChlorineSensorCatalog;
    DissolvedOxygenSensor: DissolvedOxygenSensorCatalog.DissolvedOxygenSensorCatalog;
    FlowMeter: FlowMeterCatalog.FlowMeterCatalog;
    Heater: HeaterCatalog.HeaterCatalog;
    Light: LightCatalog.LightCatalog;
    LightDriver: LightDriverCatalog.LightDriverCatalog;
    PressureSensor: PressureSensorCatalog.PressureSensorCatalog;
    Pump: PumpCatalog.PumpCatalog;
    Remote: RemoteCatalog.RemoteCatalog;
    SaltChlorinator: SwgCatalog.SwgCatalog;
}
